import api from 'src/config/api';
import {
	IGetAccessTokenFromRefreshResponse,
	ILoginCredentials,
	ILoginResponse,
} from 'src/features/auth/domain/types';

export const authApi = {
	login: async (credentials: ILoginCredentials): Promise<ILoginResponse> => {
		const response = await api.post<ILoginResponse>(
			'/api/v1/auth/email/login',
			credentials,
		);
		return response.data;
	},

	getAccessTokenFromRefresh: async (
		refreshToken: string,
	): Promise<IGetAccessTokenFromRefreshResponse> => {
		const response = await api.get('/api/v1/auth/refresh', {
			headers: {
				Authentication: `Bearer ${refreshToken}`,
			},
			skipAuthInterceptor: true,
		});
		const updatedResponse = { user_type: 'general', ...response.data };
		return updatedResponse;
	},
};
